module.exports = __webpack_public_path__ + "assets/img/1-1.7f1912a5.png";